








































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import { formatCurrency } from "@/shared/currency.js";
import {
  DrivewealthHolding,
  InstrumentStatus,
  DrivewealthAccountSummary, DrivewealthAccountManagementType
} from "@/shared/types";
import InstrumentName from "./InstrumentName.vue";
import _ from "lodash";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useUserStore } from "@/shared/store/user";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    InstrumentName,
    GenericLoadingSpinner
  }
})
export default class CurrentHoldingsTable extends mixins(ErrorsMixin) {
  formatCurrency = formatCurrency;
  SharedRoutes = SharedRoutes;

  drivewealthStore = useDrivewealthStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();

  @Prop({ required: false })
  username: string;

  @Prop({ required: false })
  partnerId: number;

  @Prop({ required: false })
  accountId: number;

  @Prop({ required: false })
  hideTrade: boolean;

  loadTable (): void {
    this.userStore.loadPartnerSettings();
    this.drivewealthStore.getAccountSummaryV2(
        { username: this.username, partnerId: this.partnerId, dwAccountId: this.accountId });
    this.drivewealthStore.loadAdvisoryFunds({ username: this.username, partnerId: this.partnerId });
  }

  @Watch("$props", { deep: true })
  reloadData (): void {
    this.loadTable();
  }

  mounted (): void {
    this.loadTable();
  }

  get accountSummaryV2 (): DrivewealthAccountSummary {
    return this.drivewealthStore.accountSummaryById(this.accountId);
  }

  routeParams (symbol: string): { symbol: string, accountId?: number, partnerId?: number } {
    if (this.accountId) {
      return { symbol, accountId: this.accountId, partnerId: this.partnerId };
    }

    return { symbol, partnerId: this.partnerId };
  }

  get accountSummaryV2RequestLoaded (): boolean {
    return this.drivewealthStore.accountSummaryV2Loaded(this.accountId);
  }

  get isLoaded (): boolean {
    return this.accountSummaryV2RequestLoaded &&
        this.drivewealthStore.advisoryFundsLoaded;
  }

  holdingFields = [
    {
      key: "toggle",
      label: "",
      thClass: "toggle-col",
      tdClass: "pt-3 align-middle",
    },
    {
      key: "instrument",
      label: "Investment",
      thClass: "text-left pl-2",
      tdClass: "pl-2 align-middle"
    },
    {
      key: "shares",
      label: "Shares",
      thClass: "text-right",
      tdClass: "text-right align-middle"
    },
    {
      key: "balance",
      label: "Balance",
      thClass: "text-right",
      tdClass: "text-right align-middle"
    },
    {
      key: "todaysReturn",
      label: "Today's Gain/Loss $",
      thClass: "text-right",
      tdClass: "text-right align-middle"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    }
  ];

  get holdingItems (): any[] {
    if (!this.accountSummaryV2) {
      return [];
    }

    return this.accountSummaryV2.holdings.map(h => ({
      instrument: { symbol: h.stockSymbol, companyName: h.fundName, website: h.webSite, imageUrl: h.imageUrl },
      fund_type: this.drivewealthStore.fundTypeDisplayCopy(h.fundType),
      isEtfOrEquity: this.drivewealthStore.isFundEtfOrEquity(h.fundType),
      shares: h.openQuantity.toFixed(2),
      price: formatCurrency(h.marketPrice),
      balance: formatCurrency(h.marketValue),
      percentage: (h.marketValue / this.accountSummaryV2.equityValue * 100).toFixed(2),
      action: { symbol: h.stockSymbol, canBuy: this.canBuyThisInstrument(h) },
      totalReturn: h.unrealizedProfitLoss,
      marketValue: h.marketValue,
      marketPrice: h.marketPrice,
      costBasis: h.costBasis,
      lastPrice: formatCurrency(h.priorClose),
      todaysReturn: ((h.marketPrice - h.priorClose) * h.openQuantity),
      rateOfReturn: (((h.marketValue - h.costBasis) / h.costBasis) * 100),
      todaysReturnPercentage: h.unrealizedDayProfitLossPercent,
      _showDetails: false,
      canExpand: true
    }));
  }

  canBuyThisInstrument (h: DrivewealthHolding): boolean {
    return h.status === InstrumentStatus.Active
        && (this.isSelfDirected || !!this.drivewealthStore.advisoryFundBySymbol(h.stockSymbol));
  }

  onRowClicked (item: any, index: number): void {
    if (item.canExpand) {
      item._showDetails = !item._showDetails;
    }
  }

  get buyRoute (): string {
    return RouteNames.DrivewealthBuyInstrumentV2;
  }

  get sellRoute (): string {
    return RouteNames.DrivewealthSellInstrumentV2;
  }

  isPositiveNumber (value: number): boolean {
    return value >= 0;
  }

  formatDisplayFiniteValue (value: number): string {
    if (_.isFinite(value)) {
      return `${value.toFixed(2)}%`;
    }

    return "N/A";
  }

  get isEmployerPortal (): boolean {
    return this.userStore.isEmployerPortal;
  }

  get employerPortalSellInstrumentEnabled (): boolean {
    return this.featureFlagStore.flags.bend23519EnablePartnerInvestmentInstrumentAllowSell &&
        this.isEmployerPortal;
  }

  get canBuySell (): boolean {
    return (this.employerPortalSellInstrumentEnabled || !this.username) &&
        !this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId) &&
        !this.userStore.partnerDisableInvestmentActivity;
  }

  get canBuySellPortfolio (): boolean {
    return (this.employerPortalSellInstrumentEnabled || !this.username) &&
        this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId) &&
        !this.userStore.partnerDisableInvestmentActivity;
  }

  get isSelfDirected (): boolean {
    return !this.username && this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.OpenBrokerage, this.accountId);
  }

  get hasPortfolio (): boolean {
    return this.accountSummaryV2RequestLoaded
        && this.accountSummaryV2.portfolioId !== null;
  }

  get isManagedAccount (): boolean {
    return this.drivewealthStore.isAccountManagementType(DrivewealthAccountManagementType.RiaManaged, this.accountId);
  }
}
